<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-row>
        <el-col :span="6">巡查类别:</el-col>
        <el-col :span="6">
          <span class="order-no">
            {{ form.action==1?'查铺查岗':form.action==2?'夜岗巡查':form.action==3?'队容风纪':'执勤战备'}}
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">备注:</el-col>
        <el-col :span="6">
          <span class="order-no">{{ form.text }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">提交时间:</el-col>
        <el-col :span="6">
          <span class="order-no"> {{ moment(form.createdTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6" v-for="item in form.imageList" :key="item">
          <el-image :src="item" class="mr-10"></el-image>
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close()">取 消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive, getCurrentInstance } from 'vue'
import moment from 'moment'
export default {
  name: 'OaCarEdit',
  emits: ['fetch-data'],
  setup(_, { emit }) {
    const { proxy } = getCurrentInstance()
    const title = ref('')
    const dialogFormVisible = ref(false)
    let form = ref({})
    const rules = {
      title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
    }
    const showDetail = async (row) => {
      console.log(row.basic.text);
        form.action=row.action
        form.value.text=row.basic.text
        form.value.imageList=row.basic.imageList
        form.createdTime=row.createdTime
        title.value = '详情'
        console.log(form);
        dialogFormVisible.value = true
    }
    const close = () => {
      dialogFormVisible.value = false
    }
    return {
      title,
      form,
      rules,
      dialogFormVisible,
      showDetail,
      close,
      moment
    }
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
.el-row {
  padding: 14px 0;
}
</style>
